export const OnlineAccountStatusOptions = [
  {
    key: "ACTIVE",
    title: "Active",
    value: "ACTIVE"
  },
  {
    key: "SUSPENDED",
    title: "Suspended",
    value: "SUSPENDED"
  },
  {
    key: "TERMINATED",
    title: "Terminated",
    value: "TERMINATED"
  }
]